import React from "react";
import type { fetchProductListingPages } from "@/services/productServices/productActions";

/**
 * SCRUM-1303: the body of the unlink / delete confirmation — the listing pages
 * the SCRUM-1301 cascade will change, one row per page, or the sentence that
 * says there are none. Both dialogs render this so an editor gets one gesture.
 *
 * An unpublished listing is listed the same way as a published one, not hidden:
 * the publish state is what tells the editor whether a live page changes.
 */
type ListingPagesAffectedProps = {
  /** The answer of GET /api/product/:id/listing-pages (`ProductListingPage[]`). */
  pages: Awaited<ReturnType<typeof fetchProductListingPages>>;
};

const ListingPagesAffected = ({ pages }: ListingPagesAffectedProps) => {
  if (!pages.length) {
    return <p data-testid="listing-pages-none">No listing page carries this product.</p>;
  }
  return (
    <div>
      <p data-testid="listing-pages-count">
        {pages.length === 1
          ? "1 listing page will change:"
          : `${pages.length} listing pages will change:`}
      </p>
      <ul className="text-left" data-testid="listing-pages">
        {pages.map((page) => (
          <li key={String(page._id)}>
            {page.site?.domain || page.site?.name || "unknown site"} — {page.path} —{" "}
            {page.publish_statement ? "published" : "unpublished"}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ListingPagesAffected;
